import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Radio" }, [
      _createElementVNode("rect", {
        x: "0.5",
        y: "1.21094",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#303333"
      }),
      _createElementVNode("circle", {
        id: "Ellipse 47",
        cx: "10",
        cy: "10.7109",
        r: "6.47266",
        fill: "#303333"
      })
    ], -1)
  ])))
}
export default { render: render }